var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeartLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_74_36",
    "data-name": "Component 74 \\u2013 36",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    fill: "rgb(255, 0, 0)",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-heart",
    "data-name": "Icon ionic-ios-heart",
    d: "M20.185,3.937h-.055a6.292,6.292,0,0,0-5.253,2.875A6.292,6.292,0,0,0,9.623,3.937H9.568a6.252,6.252,0,0,0-6.193,6.248,13.46,13.46,0,0,0,2.643,7.338,46.319,46.319,0,0,0,8.858,8.532,46.319,46.319,0,0,0,8.858-8.532,13.46,13.46,0,0,0,2.643-7.338A6.252,6.252,0,0,0,20.185,3.937Z",
    transform: "translate(9.385 9.844)",
    fill: "rgb(255, 0, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartLiked);
export default __webpack_public_path__ + "static/media/icon-heart-liked.9238875ec976a03201ab0edeecf47c55.svg";
export { ForwardRef as ReactComponent };